import IconCancel from '@pages/Payment/Components/IconCancel'
import { detectEnvUat, formatMoney } from '@utils/general'
import { Modal } from 'antd'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { RootState } from 'store'
import { Type_Initstate } from 'store/appSlice'
import { IResponeVCB } from '../../../../types/general'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: IResponeVCB | undefined
  isModalOpen: boolean
  expiresAtMs?: number
  allowCancel?: boolean
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalVCB: FC<IProps> = ({
  isModalOpen,
  img,
  setIsModalOpen,
  isSkipSelectBill,
  allowCancel,
  expiresAtMs,
}: IProps) => {
  const navigate = useNavigate()
  const params = useParams()

  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleNavigate = () => {
    navigate(
      `${detectEnvUat() ? '/uat' : ''}/organization/${params.orgCode}/school/${params.schoolCode}/student/${
        params.studentID
      }`,
    )
  }

  const handleCancel = () => {
    if (allowCancel) {
      setIsModalOpen(false)
    } else if (window.confirm('Phiếu thu chỉ có thể tạo lại sau 15 phút. Bạn có muốn thoát !')) {
      setIsModalOpen(false)
      if (isSkipSelectBill && appState?.studenInfor?.redirect_success.length > 0) {
        window.location.replace(appState?.studenInfor?.redirect_success)
      } else {
        handleNavigate()
      }
    }
  }

  return (
    <>
      <Modal
        title={<></>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={<></>}
        className="p-0 custom-modal rouder-31"
      >
        <div className="border-[25px] border-[#045993] rounded-[20px] px-[16px] py-[16px]">
          <div className="relative items-center flex flex-col justify-center rounded-[20px] ">
            <span className="absolute right-[-8px] top-[-8px]">
              <IconCancel
                handleCancel={() => {
                  handleCancel()
                }}
              />
            </span>
            <img src={require('@assets/icon/VCB2.png')} alt="" className="w-[200px] h-full" />
            <div className="border-[1px] border-[#151515] my-[8px]">
              <img src={`data:image/png;base64,${img?.qrCodeBase64}`} alt="" className="mx-auto w-full " />
            </div>
            <DownloadQrImage imageSrc={img?.qrCodeBase64} fileName="vcb-qr-thanh-toan.png" />
          </div>
          {img?.qrCodeBase64 && (
            <div className="mb-1">
              <p className="text-center text-[16px] font-[400] text-[#26538c] pb-1 mt-3">Tên trường: {img?.school}</p>

              <p className="text-center text-[16px] font-[400] text-[#26538c] pb-3">
                Số tiền: {formatMoney(img?.amount)} VND
              </p>
              <QrExpiryNotice
                isModalOpen={isModalOpen}
                paymentChannel="VCB"
                resetKey={img?.transactionCode}
                expiresAtMs={expiresAtMs}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  )
}
export default ModalVCB
